module.exports = __webpack_public_path__ + "img/face12.dd16c119.jpg";